import { MutableRefObject, useEffect, useRef } from 'react';

const useIntersectionObserver = (
    callback: IntersectionObserverCallback,
    options?: IntersectionObserverInit,
): MutableRefObject<HTMLDivElement | null> => {
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const currentRef = ref.current;
        if (!currentRef) return;

        const observer = new IntersectionObserver(callback, options);

        observer.observe(currentRef);

        return () => {
            observer.disconnect();
        };
    }, [callback, options]);

    return ref;
};

export default useIntersectionObserver;
